var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9808 9.21847L16.8869 12.0802M5.71306 20.6304L8.60431 19.7111C9.00091 19.585 9.36532 19.3764 9.67284 19.0994L18.9572 10.7366C19.8699 9.91446 19.9981 8.54365 19.2531 7.57121C18.3756 6.42578 16.6722 6.30893 15.6419 7.32348L6.72654 16.1025C6.40097 16.4231 6.15742 16.8153 6.01595 17.2467L5.10331 20.03C4.98196 20.4 5.33723 20.7499 5.71306 20.6304Z",
    stroke: "#34B2C0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/EditButton.5f95f2d56ae5432a503c6a4fc0e9ef1d.svg";
export { ForwardRef as ReactComponent };